import { render } from "./fake_delivery_note.vue?vue&type=template&id=00c93b04&scoped=true"
import script from "./fake_delivery_note.vue?vue&type=script&lang=js"
export * from "./fake_delivery_note.vue?vue&type=script&lang=js"

import "./fake_delivery_note.vue?vue&type=style&index=0&id=00c93b04&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c93b04"]])

export default __exports__